export const CHART_LINE_COLORS = {
  BLUE: '#1E84E3',
  CYAN: '#0BC9CD',
} as const
